'use client';

import { LAYOUT_SEGMENTS } from '../constants/layout-segments';

import { useIsSegmentInSelectedLayoutSegments } from './use-is-segment-in-selected-layout-segments';

export const useIsGameSegmentSelected = () => {
  const isGameOrItsNestedSegmentsSelected = useIsSegmentInSelectedLayoutSegments(LAYOUT_SEGMENTS.GAME);
  return isGameOrItsNestedSegmentsSelected;
};
